export const firstColumnBrands = {
    columnTitle: 'Gaming',
    links: [
        {
            name: 'Fallout',
            url: '/licensed/fallout?view=collections',
        },
        {
            name: 'Witcher 3',
            url: '/licensed/witcher-3?view=collections',
        },
        {
            name: 'Doom',
            url: '/licensed/doom?view=collections',
        },
        {
            name: "Assassin's Creed",
            url: '/licensed/assassins-creed?view=collections',
        },
        {
            name: 'World of Warcraft',
            url: '/licensed/world-of-warcraft?view=collections',
        },
        {
            name: 'Dungeons & Dragons',
            url: '/licensed/dungeons-and-dragons?view=collections',
        },
        {
            name: 'Call of Duty',
            url: '/licensed/call-of-duty?view=collections',
        },
        {
            name: 'Resident Evil Village',
            url: '/licensed/resident-evil-village?view=artworks',
        },
    ],
};
export const secondColumnBrands = {
    columnTitle: 'Movies, Comics',
    links: [
        {
            name: 'Star Wars',
            url: '/licensed/star-wars?view=collections',
        },
        {
            name: 'Marvel',
            url: '/licensed/marvel?view=collections',
        },
        {
            name: 'DC Comics',
            url: '/licensed/dc-comics?view=collections',
        },
        {
            name: 'Peaky Blinders',
            url: '/licensed/peaky-blinders?view=collections',
        },
        {
            name: 'Star Trek',
            url: '/licensed/star-trek?view=collections',
        },
        {
            name: 'Alien',
            url: '/licensed/alien?view=collections',
        },
        {
            name: 'Jurassic World',
            url: '/licensed/jurassic-world?view=artworks',
        },
        {
            name: 'Stranger Things',
            url: '/licensed/stranger-things-series?view=collections',
        },
    ],
};
export const thirdColumnBrands = {
    columnTitle: 'Sport',
    links: [
        {
            name: 'Dakar',
            url: '/licensed/dakar?view=collections',
        },
        {
            name: 'Arsenal',
            url: '/licensed/arsenal',
        },
        {
            name: 'FC Barcelona',
            url: '/licensed/barca?view=collections',
        },
        {
            name: 'FC Internazionale Milano',
            url: '/licensed/fc-internazionale-milano?view=collections',
        },
        {
            name: 'M-Sport Ford WRC Team',
            url: '/licensed/m-sport-ford-wrc-team?view=collections',
        },
        {
            name: 'MLB',
            url: '/licensed/major-league-baseball',
        },
        {
            name: 'West Ham',
            url: '/licensed/west-ham-united-fc?view=collections',
        },
        {
            name: 'NFLPA',
            url: '/licensed/nfl-players-association ',
        },
    ],
};
//# sourceMappingURL=brands.js.map